import React from "react";

import { Alert } from "../../../components";
import { Button, ButtonGroup } from "../../../components/ui";
// InlineOrModal: a plain ReactModal, except inside the quote workspace (no pop-ups) where it opens in place.
import InlineOrModal from "../../../core/components/InlineOrModal";
import { confirmModalStyles } from "../../../core/utils/responsiveModalStyles";

// The "Confirmation needed" prompt every price row opens before deleting — one copy instead of five.
const RemovePriceConfirm = ({ isOpen, onCancel, onRemove, inlineRow = false }) => (
  <InlineOrModal
    inlineRow={inlineRow}
    inlineClose={false}
    isOpen={isOpen}
    onRequestClose={onCancel}
    style={confirmModalStyles}
  >
    <div
      className="d-grid"
      style={{
        height: "-webkit-fill-available",
      }}
    >
      <div className="align-self-center px-4">
        <Alert
          {...{
            type: "warning",
            message: "Confirmation needed",
          }}
        />
        <ButtonGroup align="center" className="m-3">
          <Button variant="ghost" size="sm" data-btn="price-delete-cancel" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="danger" size="sm" data-btn="price-delete-confirm" onClick={onRemove}>
            Remove
          </Button>
        </ButtonGroup>
      </div>
    </div>
  </InlineOrModal>
);

export default RemovePriceConfirm;
